const ASSOC_LEFT_TO_RIGHT = 1;
const ASSOC_RIGHT_TO_LEFT = 2;

const operators = {
	'!': {
		prec: 16,
		unary: true,
		calc: (a) => ! a,
		assoc: ASSOC_RIGHT_TO_LEFT,
	},
	'*': {
		prec: 10,
		calc: (a, b) => a * b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'/': {
		prec: 10,
		calc: (a, b) => a / b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'+': {
		prec: 8,
		calc: (a, b) => a + b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'-': {
		prec: 8,
		calc: (a, b) => a - b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'==': {
		prec: 6,
		calc: (a, b) => a == b, // eslint-disable-line eqeqeq
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'!=': {
		prec: 6,
		calc: (a, b) => a != b, // eslint-disable-line eqeqeq
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'<=': {
		prec: 6,
		calc: (a, b) => a <= b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'>=': {
		prec: 6,
		calc: (a, b) => a >= b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'<': {
		prec: 6,
		calc: (a, b) => a < b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'>': {
		prec: 6,
		calc: (a, b) => a > b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'||': {
		prec: 4,
		calc: (a, b) => a || b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	'&&': {
		prec: 3,
		calc: (a, b) => a && b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
	',': {
		prec: 2,
		calc: (a, b) => b,
		assoc: ASSOC_LEFT_TO_RIGHT,
	},
};

const stringIdentifiers = ['"', '\''];

let opChars = '';
for (const op in operators) {
	opChars += op;
}

const constants = {
	'true': true,
	'false': false,
};

const SYMBOL_OPERATOR = 1;
const SYMBOL_VARIABLE = 2;
const SYMBOL_FUNCTION = 3;
const SYMBOL_GROUP = 4;
const SYMBOL_CONSTANT = 5;

function tokenize (inp) {
	const symbols = [];

	let buffer = '';
	let isOpChar = false;

	let i = 0;
	for (; i < inp.length || buffer.length; i++) {
		let isWhitespaceChar = false;
		const prevBuffer = buffer;
		let wasOpChar;
		const eof = i >= inp.length;
		let forceTokenEnd = eof;

		if (! forceTokenEnd) {
			const c = inp[i];
			isWhitespaceChar = (c === ' ');
			if (isWhitespaceChar && ! buffer.length) {
				continue;
			}
			buffer = buffer + c;
			wasOpChar = isOpChar;
			isOpChar = (opChars.indexOf(c) >= 0);

			if (c === '(') {
				if (buffer.length > 1) {
					isOpChar = true;
					forceTokenEnd = true;
				} else {
					const grp = tokenize(inp.slice(i + 1));
					const prevSymbol = symbols[symbols.length - 1];
					if (prevSymbol && prevSymbol.type === SYMBOL_VARIABLE) {
						symbols.pop();
						const args = [];
						let argBuf = [];
						for (let j = 0; j < grp.symbols.length || argBuf.length; j++) {
							const arg = grp.symbols[j];
							if (! arg || (arg.type === SYMBOL_OPERATOR && arg.value === ',')) {
								if (argBuf.length === 1) {
									args.push(argBuf[0]);
								} else if (argBuf.length > 1) {
									args.push({
										type: SYMBOL_GROUP,
										value: argBuf,
									});
								} else throw new Error('unexpected comma in fn');
								argBuf = [];
							} else {
								argBuf.push(arg);
							}
						}
						symbols.push({
							type: SYMBOL_FUNCTION,
							value: prevSymbol.value,
							args,
						});
					} else {
						symbols.push({
							type: SYMBOL_GROUP,
							value: grp.symbols,
						});
					}
					i += grp.parsedLength + 2;
					buffer = '';
					continue;
				}
			} else if (c === ')') {
				if (buffer.length <= 1) {
					return {
						symbols,
						parsedLength: i - 1,
					};
				}
				forceTokenEnd = true;
				inp = '';
			} else if (stringIdentifiers.includes(c)) { // Strings
				for (let j = i + 1; j < inp.length; j++) {
					const c2 = inp[j];
					buffer = buffer + c2;
					if (c2 === c) {
						if (inp[j - 1] === '\\') {
							buffer = buffer.slice(0, -2) + c2;
							continue;
						}
						symbols.push({
							type: SYMBOL_CONSTANT,
							value: buffer.slice(1, buffer.length - 1),
						});
						buffer = '';
						i = j;
						break;
					}
				}
				if (buffer) {
					throw new Error('Unexpected end of string');
				}
				continue;
			}
		} else {
			wasOpChar = false;
		}

		if (wasOpChar && (! isOpChar || forceTokenEnd)) {
			while (buffer.length && ! (buffer in operators)) {
				buffer = buffer.slice(0, -1);
				i--;
			}
			if (! (buffer in operators)) {
				throw new Error('Invalid operator: ' + prevBuffer + ' at position ' + i);
			}
			symbols.push({
				type: SYMBOL_OPERATOR,
				value: buffer,
			});
			buffer = '';
		} else if (! wasOpChar && (isOpChar || isWhitespaceChar || forceTokenEnd) && prevBuffer) {
			if (! isNaN(prevBuffer)) {
				const num = Number(prevBuffer);
				symbols.push({
					type: SYMBOL_CONSTANT,
					value: num,
				});
			} else { // Predefined (named) constant
				if (prevBuffer in constants) {
					symbols.push({
						type: SYMBOL_CONSTANT,
						value: constants[prevBuffer],
					});
				} else { // variable (getter)
					symbols.push({
						type: SYMBOL_VARIABLE,
						value: prevBuffer,
					});
				}
			}
			buffer = '';
			i--;
		} else if (eof && buffer.length) {
			throw new Error('Unexpected end of input');
		}
	}

	return {
		symbols,
		parsedLength: i,
	};
}

function valueFromSymbol (symbol, handlers) {
	switch (symbol.type) {
	case SYMBOL_VARIABLE:
		return handlers.get(symbol.value);
	case SYMBOL_CONSTANT:
		return symbol.value;
	case SYMBOL_FUNCTION:
		const args = [];
		for (const arg of symbol.args) {
			args.push(valueFromSymbol(arg, handlers));
		}
		return handlers.call(symbol.value, args);
	case SYMBOL_GROUP:
		return evaluate(symbol.value, handlers);
	}
	throw new Error('something very bad happened )):');
}

// @TODO check for unmatched group separators
function evaluate (symbols, handlers) {
	whileLoop:
	while (symbols.length > 1) {
		let topPrec = 0;
		let topInd = -1;
		for (let i = 0; i < symbols.length; i++) {
			const s = symbols[i];
			if (s.type === SYMBOL_OPERATOR) {
				const op = operators[s.value];
				const assoc = op.assoc || ASSOC_LEFT_TO_RIGHT;
				if (assoc === ASSOC_LEFT_TO_RIGHT ? op.prec > topPrec : op.prec >= topPrec) {
					topPrec = op.prec;
					topInd = i;
				}
			} else if (s.type === SYMBOL_GROUP) {
				symbols[i] = {
					value: evaluate(s.value, handlers),
					type: SYMBOL_CONSTANT,
				};
				continue whileLoop;
			}
		}
		if (topInd >= 0) {
			const op = operators[symbols[topInd].value];
			const post = valueFromSymbol(symbols[topInd + 1], handlers);
			if (op.unary) {
				symbols[topInd] = {
					value: op.calc(post),
					type: SYMBOL_CONSTANT,
				};
				symbols.splice(topInd + 1, 1);
			} else {
				const pre = valueFromSymbol(symbols[topInd - 1], handlers);
				symbols[topInd - 1] = {
					value: op.calc(pre, post),
					type: SYMBOL_CONSTANT,
				};
				symbols.splice(topInd, 2);
			}
		} else throw new Error('omg eval dunno wat do! JSON:' + JSON.stringify(symbols));
	}
	if (symbols[0].type !== SYMBOL_CONSTANT) {
		return valueFromSymbol(symbols[0], handlers);
	}
	return symbols[0].value;
}

function run (statement, handlers) {
	if (typeof statement !== 'object') {
		statement = tokenize(statement);
	}
	const result = evaluate(JSON.parse(JSON.stringify(statement.symbols)), handlers);
	return result;
}

export default {
	run,
	tokenize,
};
